
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaSkipPrevious as ObiMediaSkipPreviousElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-skip-previous.js';
 
 
 

 
 export const ObiMediaSkipPrevious = createComponent({
   react: React,
   tagName: 'obi-media-skip-previous',
   elementClass: ObiMediaSkipPreviousElement,
   events: {
     
   }
  });
 
 